import * as React from 'react'
import { useEffect, useMemo } from 'react'
import { useDispatch } from 'react-redux'
import { Button, Tooltip } from '@fluentui/react-components'
import { ArrowDownloadFilled, ArrowDownloadRegular, bundleIcon } from '@fluentui/react-icons'
import { useTranslation } from 'react-i18next'
import { useFormikContext } from 'formik'
import { AppAction } from '../../../config/appConfig'
import { MenuItemKey } from '../../../components/MainMenu'
import { FileAction } from '../../../config/fileConfig'
import BasePartyOverview, { HeaderCreateActionsButton, PartyFilterType } from '../Party/BasePartyOverview'
import useRoles, { Role } from '../../../hooks/useRoles'
import useSubmitDocumentGenerationRequest from '../../../hooks/finance/report/useSubmitDocumentGenerationRequest'
import { DocumentGenerationType } from '../../../hooks/document/documentGenerationTypes'
import { parseFilterValuesToParams } from '../../../pages/BaseOverview/BaseOverview'
import { useHistory } from 'react-router-dom'

const DownloadIcon = bundleIcon(ArrowDownloadFilled, ArrowDownloadRegular)

function CRMHeaderActionsButtons() {
    const roles = useRoles()
    const { t: translate } = useTranslation()
    const { values } = useFormikContext<PartyFilterType>()

    const submitFileReportRequest = useSubmitDocumentGenerationRequest<PartyFilterType>(DocumentGenerationType.CRMFileXls)

    return (
        <>
            <HeaderCreateActionsButton />
            {roles.all([Role.Report]) && (
                <Tooltip withArrow relationship={'label'} content={translate('crm.action.download.files')}>
                    <Button
                        icon={<DownloadIcon />}
                        appearance={'secondary'}
                        onClick={() => submitFileReportRequest(parseFilterValuesToParams(values))}
                    />
                </Tooltip>
            )}
        </>
    )
}

export default function CRMOverview() {
    const dispatch = useDispatch()
    const history = useHistory()

    useEffect(() => {
        dispatch({ type: AppAction.SetBreadcrumbs, payload: [MenuItemKey.CRM] })
        dispatch({ type: FileAction.ResetCurrent })
    }, [])

    const fixedFilterValues = useMemo<PartyFilterType>(
        () => ({
            crmRelation: true,
        }),
        [],
    )

    return (
        <BasePartyOverview
            fixedFilterValues={fixedFilterValues}
            headerActionsButtons={CRMHeaderActionsButtons}
            inputPlaceholderKey={'crm.filter.search'}
            localStorageKeyPrefix={'HammockCRMOverview'}
            onItemClicked={props => history.push(`/crm/${props.item.id}/file`)}
        />
    )
}
